module.exports = __webpack_public_path__ + "img/cju_gallery3.298ca3db.jpg";